import { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  MenuItem,
  Grid2,
  Grid,
  IconButton,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import Editicon from "../../../assets/images/Edit.png";
import {
  DatePicker,
  DesktopTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { baseFetch } from "../../../helpers/apiClient";
import { prepareEventMedia } from "../../../helpers/uploadEventFile";
import SuccessModal from "../../../components/SuccessModal";
import { useNavigate } from "react-router-dom";
import { categoryList } from "../../../constants/categories";
import { formatEventType } from "../../../constants/RegionalLocationList";
import RoundedTextField from "../../../components/RoundedTextField";
import { styles } from "./style";
import RoundedSelect from "../../../components/RoundedSelect";
import Loader from "../../../components/Loader";
import DashboardFooter from "../../../components/Footer";
import ImageCropper from "../../../components/ImageCropper";
import EventSubmissionPopup from "../../../components/EventSubmissionPopup";
import FileUpload from "../../../components/FileUpload";
import { EventFormContext } from "../../../context/EventFormContext";
import { useSnackbar } from "../../../context/SnackbarContext";
import { useSelector } from "react-redux";
import PostingLimitModal from "../../../components/PostingLimitModal";
import {
  timezoneOptions,
  isValidEventUrl,
  EVENT_URL_ERROR_MESSAGE,
} from "../../../helpers/constants";
import RichTextEditor from "../../../components/RichTextEditor";

export const formatParticipant = (value) => {
  let formattedValue = value.replace(/\D/g, "");
  return formattedValue;
};

export default function CreateEventFrom() {
  const navigate = useNavigate();
  const filteredList = categoryList.slice(1);
  const [errorMsg, setErrorMsg] = useState("");
  const { formData, setFormData } = useContext(EventFormContext);
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const completedUploads = useRef(new WeakMap());
  const submissionController = useRef(null);
  useEffect(() => () => submissionController.current?.abort(), []);
  const [open, setOpen] = useState(false);
  const [openImageCropper, setOpenImageCropper] = useState(false);
  const fileInputRef = useRef(null);
  const [eventSubmissionModal, setEventSubmissonModal] = useState(false);
  const [openPostLimitModal, setOpenPostLimitModal] = useState(false);
  const { showSnackbar } = useSnackbar();
  const contentSizeInfo = useSelector(
    (state) => state?.profileSlice?.profile?.contentSizeInfo,
  );
  const handleVideoChange = (file) => {
    //setFile(e.target.files[0])
    setFormData((prevFormData) => ({
      ...prevFormData,
      resourceFile: file,
      resourceFileUrl: URL.createObjectURL(file),
      resourceFileName: file.name,
      resouceFileSize: file.size,
    }));
  };

  const handleFileChange = (event) => {
    setOpenImageCropper(true);
    const allowedFileType = ["image/jpeg", "image/jpg", "image/png"];
    const file = event.target.files[0];

    if (file && allowedFileType.includes(file.type)) {
      setImage(URL.createObjectURL(file));
      setErrorMsg("");
    } else {
      setErrorMsg("Invalid file type (only jpg/jpeg/png files are allowed)");
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleImageUpload = (file) => {
    setFormData({ ...formData, photo: file });
    setOpenImageCropper(false);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
    // Only update state if word count is less than or equal to 1000
    if (wordCount <= 1000 && value?.split(" ")?.[1000] != "") {
      setFormData({
        ...formData,
        eventDescription: value,
      });
    }
  };

  console.log(formData, "formData");
  const showDateAndTime =
    formData.eventType === "Webinars" ||
    formData.eventType === "Virtual Events" ||
    formData.eventType === "";

  const showEventUrl =
    formData.eventType === "Webinars" ||
    formData.eventType === "Virtual Events" ||
    formData.eventType === "Articles and Blogs";

  const submitForm = async () => {
    if (submissionController.current) return;
    const controller = new AbortController();
    submissionController.current = controller;
    setLoading(true);
    setErrorMsg("");
    if (formData.eventType === "Articles and Blogs") {
      setEventSubmissonModal(false);
    }
    try {
      const fields = {
        eventTitle: formData.eventTitle,
        eventType: formatEventType("value", formData.eventType),
        eventUrl: formData.eventUrl,
        eventDescription: formData.eventDescription,
        photo: formData.photo,
      };
      if (showDateAndTime) {
        Object.assign(fields, {
          eventDateStart: moment(formData.eventDateStart).format("YYYY-MM-DD"),
          eventDateEnd: moment(formData.eventDateEnd).format("YYYY-MM-DD"),
          eventTimeStart: formData.eventTimeStart,
          eventTimeEnd: formData.eventTimeEnd,
          timezone: formData.timezone,
          numberOfParticipants: formData.numberOfParticipants,
        });
      } else if (formData.resourceFile != null) {
        fields.resourceFile = formData.resourceFile;
      }
      const body = await prepareEventMedia(fields, completedUploads.current, {
        signal: controller.signal,
      });
      const response = await baseFetch({
        url: "/v1/web/event/create",
        method: "POST",
        signal: controller.signal,
        body,
      });
      if (response.status && response.message === "EventCreatedSuccessful") {
        setOpen(true);
        setFormData({
          eventTitle: "",
          eventType: "",
          eventDateStart: null,
          eventDateEnd: null,
          eventTimeStart: null,
          eventTimeEnd: null,
          eventUrl: "",
          numberOfParticipants: "",
          eventDescription: "",
          photo: null,
          resourceFile: null,
        });
      }
    } catch (error) {
      if (!controller.signal.aborted) {
        showSnackbar({ message: error?.message ?? error });
      }
    } finally {
      submissionController.current = null;
      if (!controller.signal.aborted) setLoading(false);
    }
  };

  const handleSubmit = () => {
    setErrorMsg("");

    if (formData.numberOfParticipants > 100) {
      setErrorMsg("Maximum number of participants allowed is 100");
      return;
    }

    if (
      formData.eventType === "Articles and Blogs" &&
      formData.eventDescription === ""
    ) {
      setEventSubmissonModal(true);
      return;
    }

    // Validate time: End time must be after start time
    if (showDateAndTime && formData.eventTimeStart && formData.eventTimeEnd) {
      const start = moment(formData.eventTimeStart, "hh:mm A");
      const end = moment(formData.eventTimeEnd, "hh:mm A");

      if (!end.isAfter(start)) {
        setErrorMsg("End time must be after start time");
        return;
      }
    }

    submitForm();
  };

  function hasAllValues(obj) {
    console.log("photo is", formData.photo);
    if (
      formData.eventType === "Webinars" ||
      formData.eventType === "Virtual Events"
    ) {
      if ("resourceFile" in obj) {
        delete obj.resourceFile;
      }
      return Object.values(obj).every(
        (value) => value !== "" && value !== null,
      );
    } else if (formData.eventType === "Articles and Blogs") {
      return (
        formData.photo &&
        formData.eventTitle &&
        formData.eventType &&
        (formData.resourceFile || formData?.eventUrl)
      );
    } else if (formData.eventType === "Videos and Presentations") {
      return (
        formData.photo &&
        formData.eventTitle &&
        formData.eventType &&
        formData.resourceFile &&
        formData.eventDescription
      );
    } else {
      return (
        formData.photo &&
        formData.eventTitle &&
        formData.eventType &&
        formData.eventDescription
      );
    }
  }

  const handleLogoutClose = () => {
    setEventSubmissonModal(false);
  };

  const disable = hasAllValues(formData) ? false : true;

  const handleDialogClose = () => {
    setOpenImageCropper(false);
  };
  const handleConfirmLogout = () => {
    submitForm();
  };
  return (
    <Box>
      <Grid2 container spacing={4}>
        <Grid2
          item
          size={{ xs: 12, sm: 11, md: 10, lg: 9 }}
          sx={{ margin: "auto" }}
        >
          {loading && <Loader />}
          <Box
            sx={{
              background: "#FFFFFF",
              padding: "20px",
              borderRadius: "10px",
              marginTop: "20px",
              width: "100%",
            }}
          >
            <Grid container spacing={4}>
              <Grid xs={12} sm={12} md={6} item>
                <Box sx={styles.container}>
                  <Box sx={styles.imageContainer}>
                    {formData.photo ? (
                      <img
                        src={URL.createObjectURL(formData.photo)}
                        alt="Cover"
                        style={styles.selectedImage}
                      />
                    ) : (
                      <Box
                        component="img"
                        src="/images/icons/dummy-img-icon1.png"
                        alt="profile icon"
                        sx={styles.dummyImage}
                      />
                    )}
                    <IconButton sx={styles.iconButtonStyle} component="label">
                      <input
                        name="photo"
                        hidden
                        accept="image/jpg,image/jpeg,image/png"
                        type="file"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                      />
                      <img width={"14px"} src={Editicon} />
                    </IconButton>
                    {image && (
                      <ImageCropper
                        open={openImageCropper}
                        image={image}
                        onCrop={handleImageUpload}
                        onCancel={handleDialogClose}
                        aspectRatio={16 / 9}
                      />
                    )}
                  </Box>
                  <Box sx={styles.eventTitleContainer}>
                    <Typography sx={styles.labelText} component="dt">
                      Title
                    </Typography>
                    <RoundedTextField
                      fullWidth
                      name="eventTitle"
                      size="small"
                      placeholder="Enter here"
                      value={formData.eventTitle}
                      onChange={(e) =>
                        setFormData({ ...formData, eventTitle: e.target.value })
                      }
                      sx={styles.textField}
                    />
                  </Box>
                  <Grid2 container spacing={2}>
                    <Grid2 item xs={12} sx={{ width: "100%" }}>
                      <Typography sx={styles.labelText} component="dt">
                        Select Content Type
                      </Typography>
                      <RoundedSelect
                        value={formData.eventType}
                        onChange={(e) => {
                          if (
                            e.target.value != "Articles and Blogs" &&
                            e.target.value != "Videos and Presentations" &&
                            contentSizeInfo?.notAllowedContent?.length > 0
                          ) {
                            setOpenPostLimitModal(true);
                          } else {
                            setFormData({
                              ...formData,
                              eventType: e.target.value,
                              ...(e.target.value === "Articles and Blogs" ||
                              e.target.value === "Videos and Presentations"
                                ? { resourceFile: null }
                                : {}),
                            });
                          }
                        }}
                        placeholder="Select"
                        displayEmpty
                        renderValue={(selected) => {
                          // Show placeholder when no value is selected
                          if (!selected) {
                            return (
                              <span style={{ color: "#AAB6C8" }}>Select</span>
                            );
                          }
                          return selected;
                        }}
                        inputProps={{ "aria-label": "Without label" }}
                        sx={styles.selectField}
                      >
                        {filteredList.map((category) => (
                          <MenuItem key={category.key} value={category.value}>
                            {category.value}{" "}
                            {formData.eventType === category.value && (
                              <CheckCircle
                                sx={{
                                  marginLeft: "auto",
                                  color: "#2A4876",
                                  width: "14px",
                                }}
                              />
                            )}
                          </MenuItem>
                        ))}
                      </RoundedSelect>
                    </Grid2>
                  </Grid2>
                  {showDateAndTime && (
                    <>
                      <Typography sx={styles.labelText} component="dt">
                        {formData?.eventType === "Virtual Events"
                          ? "Event Date"
                          : "Date"}
                      </Typography>
                      <Box sx={{ width: "100%" }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ paddingTop: 0 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DatePicker
                                value={formData.eventDateStart}
                                slotProps={{
                                  textField: {
                                    placeholder: "Start Date",
                                  },
                                }}
                                onChange={(date) =>
                                  setFormData({
                                    ...formData,
                                    eventDateStart: date,
                                    eventDateEnd: date,
                                  })
                                }
                                sx={styles.datePicker}
                                format="MMM DD, YYYY"
                                minDate={moment().add(16, "days")}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <Grid container spacing={2}>
                          <Grid xs={12} sm={12} md={12} item>
                            <Typography sx={styles.labelText} component="dt">
                              Timezone
                            </Typography>
                            <RoundedSelect
                              value={formData.timezone}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  timezone: e.target.value,
                                })
                              }
                              placeholder="Select Timezone"
                              displayEmpty
                              renderValue={(selected) => {
                                if (!selected)
                                  return (
                                    <span style={{ color: "#AAB6C8" }}>
                                      Select Timezone
                                    </span>
                                  );
                                const selectedOption = timezoneOptions.find(
                                  (t) => t.value === selected,
                                );
                                return selectedOption
                                  ? selectedOption.label
                                  : selected;
                              }}
                              inputProps={{ "aria-label": "timezone-select" }}
                              sx={styles.selectField}
                            >
                              {timezoneOptions.map((tz) => (
                                <MenuItem key={tz.value} value={tz.value}>
                                  {tz.label}
                                  {formData.timezone === tz.value && (
                                    <CheckCircle
                                      sx={{
                                        marginLeft: "auto",
                                        color: "#2A4876",
                                        width: "14px",
                                      }}
                                    />
                                  )}
                                </MenuItem>
                              ))}
                            </RoundedSelect>
                          </Grid>
                        </Grid>
                      </Box>
                      <Typography sx={styles.labelText} component="dt">
                        {formData?.eventType === "Virtual Events"
                          ? "Event Time"
                          : "Time"}
                      </Typography>
                      <Box sx={{ width: "100%" }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DesktopTimePicker
                                value={
                                  formData.eventTimeStart
                                    ? moment(formData.eventTimeStart, "hh:mm A")
                                    : null
                                }
                                onChange={(time) =>
                                  setFormData({
                                    ...formData,
                                    eventTimeStart: time
                                      ? time.format("hh:mm A")
                                      : "",
                                    eventTimeEnd: time
                                      ? time.format("hh:mm A")
                                      : "",
                                  })
                                }
                                sx={styles.timePicker}
                                slotProps={{
                                  textField: {
                                    placeholder: "Start Time",
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            className="marginTop-15"
                            style={{ paddingTop: 0 }}
                          >
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DesktopTimePicker
                                value={
                                  formData.eventTimeEnd
                                    ? moment(formData.eventTimeEnd, "hh:mm A")
                                    : null
                                }
                                onChange={(time) =>
                                  setFormData({
                                    ...formData,
                                    eventTimeEnd: time
                                      ? time.format("hh:mm A")
                                      : "",
                                  })
                                }
                                sx={styles.timePicker}
                                slotProps={{
                                  textField: {
                                    placeholder: "End Time",
                                  },
                                }}
                                minTime={
                                  formData.eventTimeStart
                                    ? moment(formData.eventTimeStart, "hh:mm A")
                                    : null
                                }
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  )}
                </Box>
              </Grid>
              <Grid xs={12} sm={12} md={6} item>
                <Box
                  sx={styles.eventTitleContainer}
                  style={{ marginBottom: "15px" }}
                >
                  {" "}
                  <Typography mb={0.5} sx={styles.labelText} component="dt">
                    {formData.eventType === "Articles and Blogs"
                      ? "Description(Optional)"
                      : "Description"}
                  </Typography>
                  <RichTextEditor
                    value={formData.eventDescription ?? ""}
                    onChange={(value) =>
                      handleChange({
                        target: { name: "eventDescription", value },
                      })
                    }
                    placeholder="Enter here..."
                    style={{
                      border: "none",
                      borderRadius: "50px",
                      backgroundColor: "#F2F7FB",
                      padding: "10px 15px",
                      minHeight: "300px",
                      color: "#2A4876",
                      // textTransform: 'capitalize',
                    }}
                    className="custom-quill"
                  />
                  <Typography
                    sx={{
                      position: "relative",
                      bottom: -6, // Pushes it just below the TextField
                      left: 10, // Aligns it to the right side
                      fontSize: "12px",
                      color: "gray",
                      px: 1, // Optional horizontal padding
                      "@media (max-width: 600px)": {
                        fontSize: "11px",
                        bottom: -5,
                      },
                      textAlign: "right",
                    }}
                  >
                    {`${
                      formData.eventDescription
                        .replace(/<[^>]*>/g, "") // strip HTML tags
                        .trim()
                        .split(/\s+/)
                        .filter(Boolean).length
                    }
                    /1000`}
                  </Typography>
                </Box>

                <Box sx={styles.eventTitleContainer}>
                  {showEventUrl && (
                    <>
                      <Typography mb={0.5} sx={styles.labelText} component="dt">
                        {formData?.eventType === "Articles and Blogs" ||
                        formData?.eventType !== "Virtual Events"
                          ? "URL"
                          : "Event URL"}
                      </Typography>
                      <RoundedTextField
                        fullWidth
                        size="small"
                        name="eventUrl"
                        onChange={(e) =>
                          setFormData({ ...formData, eventUrl: e.target.value })
                        }
                        placeholder="Enter here"
                        value={formData?.eventUrl}
                        disabled={formData.resourceFile}
                        error={!isValidEventUrl(formData?.eventUrl)}
                        helperText={
                          !isValidEventUrl(formData?.eventUrl)
                            ? EVENT_URL_ERROR_MESSAGE
                            : ""
                        }
                        sx={{
                          marginBottom: "12px",
                          borderRadius: "50px",
                          backgroundColor: "#F2F7FB",
                          textTransform: "capitalize",
                          "& .MuiInputBase-input": {
                            color: "#2A4876",
                          },
                        }}
                      />
                    </>
                  )}
                  {!showDateAndTime && (
                    <FileUpload
                      eventType={formData.eventType}
                      formData={formData}
                      handleVideoChange={handleVideoChange}
                      file={formData.resourceFile}
                      setFormData={setFormData}
                      disabled={formData?.eventUrl}
                    />
                  )}
                </Box>
                {showDateAndTime && (
                  <Box sx={styles.eventTitleContainer}>
                    <Typography mb={0.5} sx={styles.labelText} component="dt">
                      Number of Participants
                    </Typography>
                    <RoundedTextField
                      fullWidth
                      size="small"
                      name="numberOfParticipants"
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericValue = Number(inputValue);
                        // Block 0 or negative values
                        if (inputValue && numericValue === 0) return;

                        setFormData({
                          ...formData,
                          numberOfParticipants: formatParticipant(inputValue),
                        });
                      }}
                      placeholder="Enter here (max 100)"
                      value={formData?.numberOfParticipants}
                      sx={{
                        marginBottom: "12px",
                        borderRadius: "50px",
                        backgroundColor: "#F2F7FB",
                        textTransform: "capitalize",
                        "& .MuiInputBase-input": {
                          color: "#2A4876",
                        },
                      }}
                    />
                  </Box>
                )}
                <Box sx={styles.eventTitleContainer}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={styles.createButton}
                    onClick={() => handleSubmit()}
                    style={{
                      backgroundColor: !disable ? "#2A4876" : "#AAB6C8", // Change backgroundColor based on input values
                      color: "#fff",
                      fontSize: "18px",
                      cursor: disable ? "not-allowed" : "pointer", // Disable hover effect when fields are not filled
                    }}
                    disabled={disable || loading} // Disable while media is uploading.
                  >
                    Publish
                  </Button>
                  {errorMsg && (
                    <Typography sx={{ color: "red" }}>{errorMsg}</Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
          {open && (
            <SuccessModal
              open={open}
              onClose={() => {
                setOpen(false);
                navigate("/dashboard");
              }}
              title="Your Content Has Been Submitted for Approval!"
              subTitle="Thank you for contributing to the Echo community! Our team is reviewing your content details, and once approved, it will be ready to engage and inspire our users. If any adjustments are needed, we’ll be in touch. We appreciate your commitment to sharing valuable content on Echo!"
            />
          )}
          {eventSubmissionModal && (
            <EventSubmissionPopup
              logoutDialogOpen={eventSubmissionModal}
              handleConfirmLogout={handleConfirmLogout}
              handleLogoutClose={handleLogoutClose}
            />
          )}
          {openPostLimitModal && (
            <PostingLimitModal
              open={openPostLimitModal}
              onClose={() => setOpenPostLimitModal(false)}
              maxedOutContent={contentSizeInfo?.notAllowedContent}
              allowedContent={contentSizeInfo?.allowedContent}
            />
          )}
        </Grid2>
      </Grid2>
      <DashboardFooter />
    </Box>
  );
}
